export const RB_YELLOW = "#fad201";
export const RB_YELLOW_DARK_10 = "#e1bd00";
export const RB_BLACK = "#000";

export const RB_LIGHT_SHADOW = "#0003";
